resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
  Carousel

  Carousel widget that cycles through (shows/hides) slides that contain images and description.
  Description is always shown, and images are cycled (shows/hides) and text "highlighted" as
  cycled to the current slide.

  HTML structure:
    A <ul> (unordered list) structure with list items of class "slide" and children elements
    specified by slide__image and slide__description classed containers.

    ul(data-mogo-ui="Carousel")
      li.slide
        .slide__image
          div(style="background-image:url('image1.jpg')")
        .slide__description
      li.slide
        .slide__image(style="background-image:url('image2.jpg')")
        .slide__description
      ... (additional slides)

  Arguments:
    carouselHeight (optional) [Integer]:
      Defaults to 200. The height of the image section of the carousel, in pixels.
    initialSlide (optional) [Integer]:
      Defaults to 0. Index of initial slide.
    interval (optional) [Integer]:
      Defaults to 9000. A number, in milliseconds of the length of time each slide is shown
      before it cycles to the next slide.
*/
function Carousel() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_ScrollingLayout];

  // props
  this.carouselHeight = 200;
  this.initialSlide = 0;
  this.interval = 9000;
  this.rotateOnView = false;

  // internal variables
  this._currentSlide = -1;
  this._interval = null;
  this._viewed = false;

  this.init = function() {
    this.$node = $(this.node);
    $(this.node).addClass("show");

    // Set carousel height
    $(this.node).css("min-height", this.carouselHeight + "px");
    $(this.node).css("padding-top", this.carouselHeight + "px");

    // Set height of images
    var imageContainers = $(".slide", this.node);
    for (var i = 0; i < imageContainers.length; i++) {
      // Set connections
      var ind = i;
      $(imageContainers[i]).on("click", $.proxy(this.setCurrentSlide, this, ind));

      // Set heights
      var images = $(".slide__image", imageContainers[i]).children();
      for (var j = 0; j < images.length; j++) {
        $(images[j]).css("height", this.carouselHeight + "px");
      }
    }


    if(this.rotateOnView) {
      // set callback for when $(this.node) comes into view
      this.registerOnView(this._scrollCallback.bind(this), this.$node);
    }


    // Visibility change handler
    $(document).on("visibilitychange.carousel", $.proxy(this._onVisibilityChange, this));
  };

  this.initAllReady = function() {
    this.setCurrentSlide(this.initialSlide);
    this.resetInterval();
  };


  this._scrollCallback = function() {
    this._viewed = true;
    this.resetInterval();
  };

  this.setCurrentSlide = function(index) {
    var children = $(".slide", this.node);

    if (children[index]) {
      // Remove current active
      if (this._currentSlide != -1) {
        $(".slide__image", children[this._currentSlide]).removeClass("active");
        $(".slide__description", children[this._currentSlide]).removeClass("active");
      }

      // Add current active
      $(".slide__image", children[index]).addClass("active");
      $(".slide__description", children[index]).addClass("active");
      this._currentSlide = index;
      this.resetInterval();

      return true;
    }

    return false;
  };

  this.resetInterval = function() {
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }

    if (this._interval === null && !document.hidden && (!this.rotateOnView || (this.rotateOnView && this._viewed) )) {
      this._interval = setInterval($.proxy(this._transition, this), this.interval);
    }
  };

  this.destroy = function() {
    $(document).off("visibilitychange.carousel");
  };

  this._transition = function() {
    var children = $(".slide", this.node);
    var slideTo = this._currentSlide + 1;

    if (slideTo >= children.length) {
      slideTo = 0;
    }

    this.setCurrentSlide(slideTo);
  };

  this._onVisibilityChange = function() {
    this.resetInterval();
  };
}
